module.exports = __webpack_public_path__ + "img/icon_take_effect1.4e67489d.png";